import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { PairTickers, PairTrend } from '@root/entities/pair/ui'
import { Separator as Separator_ } from '@root/shared/ui-kit'

import type { AggregatedPositionModel } from '@root/entities/position'

type TradePositionPairProps = {
  position: AggregatedPositionModel
}

export const TradePositionPair: React.FC<TradePositionPairProps> = ({
  position,
}) => {
  const { pair } = position

  const [remainingSizeCurrency] = useAtom(position.remainingSizeCurrency)
  const [remainingSizeUsd] = useAtom(position.remainingSizeUsd)
  const [pnlUsd] = useAtom(position.pnlUsd)

  return (
    <Root>
      <CurrencyIcon withNetwork size={40} currency={pair.quote} />
      <PairContainer>
        <Tickers
          quote={pair.quote}
          base={pair.base}
          premiumInfo={pair.premiumInfo}
        />
        <PairTrend
          changePercents={pnlUsd.pnlPercentage.toNumber()}
          showPercents
        />
      </PairContainer>
      <Separator vertical />
      <div>
        <SizeNative>
          <Numeric
            value={remainingSizeCurrency}
            preset="currency-amount-short"
            currency={pair.quote.ticker}
          />
        </SizeNative>
        <SizeUsd>
          <Numeric
            value={remainingSizeUsd}
            preset="currency-amount-short"
            currency="$"
          />
        </SizeUsd>
      </div>
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  padding-block: 18px;
  padding-inline: 25px;

  box-shadow: inset 0 0 0 1px var(--grayA-2);
  background: linear-gradient(
    180deg,
    var(--backgroundA-3) 0%,
    var(--backgroundA-2) 100%
  );
  backdrop-filter: blur(5px);

  display: grid;
  grid-template-columns: auto auto 1fr auto;
`

const Separator = styled(Separator_)`
  justify-self: center;
  background: var(--backgroundA-2);
`

const SizeNative = styled.div`
  color: var(--text-12);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`
const SizeUsd = styled.div`
  color: var(--textA-7);
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
`

const PairContainer = styled.div`
  padding-inline: 12px;
  gap: 3px;

  display: grid;
  justify-items: start;
  align-content: center;
`

const Tickers = styled(PairTickers)`
  font-size: 14px;
`
